// extracted by mini-css-extract-plugin
export default {"mobileMenuMax":"1024px","heading":"heading-3LwKGe","flush":"flush-3tQdEi","contentPrimary":"contentPrimary-Ud_VxP","contentSecondary":"contentSecondary-3MwfB_"};